import React, { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { RewardAwarded } from '@bonanza-social/moonlight';
import { DailyGiftAwardedProps } from './DailyGiftAwarded.types';

function DailyGiftAwarded({
  rewardAmount,
  nextAvailableAt,
  handleGoToShop,
}: DailyGiftAwardedProps) {
  const { t } = useTranslation('dailyGift');

  return (
    <RewardAwarded
      title={t('awardedTitle')}
      rewardText={t('bonanzaCoins')}
      rewardIcon="bonanzaCoin"
      rewardAmount={rewardAmount}
      nextRewardText={t('nextGift')}
      nextAvailableAt={nextAvailableAt}
      buttonLocNS="dailyGift"
      buttonLocKey="awardedCta"
      onButtonPress={handleGoToShop}
      light={true}
    />
  );
}

export default memo(DailyGiftAwarded);
